/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:11:28
 * @FilePath: \baishu_react_ui\src\Login\BsyAlertImgCode\Staticize.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Dialog from './index'

const imgCodeAlert = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if(document.getElementsByClassName("BsyAlertImgCode").length>0){
            holder = document.getElementsByClassName("BsyAlertImgCode")[0]
        }else{
            holder = document.createElement('div');
            holder.classList.add("BsyAlertImgCode");
            document.body.appendChild(holder)
            holder.style.zIndex = 10000;
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertImgCodeContent");
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertImgCodeContent").length>3){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
        const newProps={...props,target:holderTo}

        ReactDOM.render(
            <Dialog
                {...newProps}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('imgCodeAlert',res);
    })

export default imgCodeAlert